(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mangmi-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviewScroll = (root = document) => {
      root.querySelectorAll('[data-mangmi-reviews-viewport]').forEach((viewport) => {
        if (viewport.dataset.mangmiReviewsInitialized === 'true') return;

        const list = viewport.querySelector('[data-mangmi-reviews-list]');
        const previousButton = viewport.querySelector('[data-mangmi-reviews-previous]');
        const nextButton = viewport.querySelector('[data-mangmi-reviews-next]');

        if (!list || !previousButton || !nextButton) return;

        const updateButtons = () => {
          const maximumScroll = Math.max(0, list.scrollWidth - list.clientWidth);
          previousButton.disabled = list.scrollLeft <= 2;
          nextButton.disabled = list.scrollLeft >= maximumScroll - 2;
        };

        const getScrollStep = () => {
          const firstCard = list.querySelector('.mangmi-customer-reviews__card');
          if (!firstCard) return list.clientWidth;
          const styles = window.getComputedStyle(list);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          return firstCard.getBoundingClientRect().width + gap;
        };

        previousButton.addEventListener('click', () => {
          list.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        });

        nextButton.addEventListener('click', () => {
          list.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        });

        let scrollFrame;
        list.addEventListener('scroll', () => {
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(updateButtons);
        }, { passive: true });

        let pointerStart = 0;
        let scrollStart = 0;
        let dragging = false;

        list.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragging = true;
          pointerStart = event.clientX;
          scrollStart = list.scrollLeft;
          list.setPointerCapture(event.pointerId);
          list.classList.add('mangmi-customer-reviews__list--dragging');
        });

        list.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          const distance = event.clientX - pointerStart;
          if (Math.abs(distance) > 3) event.preventDefault();
          list.scrollLeft = scrollStart - distance;
        });

        const stopDragging = (event) => {
          if (!dragging) return;
          dragging = false;
          list.classList.remove('mangmi-customer-reviews__list--dragging');
          if (list.hasPointerCapture(event.pointerId)) {
            list.releasePointerCapture(event.pointerId);
          }
        };

        list.addEventListener('pointerup', stopDragging);
        list.addEventListener('pointercancel', stopDragging);
        window.addEventListener('resize', updateButtons);

        viewport.dataset.mangmiReviewsInitialized = 'true';
        updateButtons();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeReviewScroll());
    } else {
      initializeReviewScroll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeReviewScroll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mangmi-feature-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMangmiFeatureGrids = (scope = document) => {
      const sections = scope.classList && scope.classList.contains('mangmi-feature-grid')
        ? [scope]
        : scope.querySelectorAll('.mangmi-feature-grid');

      sections.forEach((section) => {
        if (section.dataset.mangmiFeatureGridReady === 'true') return;

        const track = section.querySelector('[data-mangmi-feature-grid-track]');
        const controls = section.querySelector('[data-mangmi-feature-grid-controls]');
        const previousButton = section.querySelector('[data-mangmi-feature-grid-previous]');
        const nextButton = section.querySelector('[data-mangmi-feature-grid-next]');

        if (!track || !controls || !previousButton || !nextButton) return;

        section.dataset.mangmiFeatureGridReady = 'true';

        const updateControls = () => {
          const isDesktop = window.matchMedia('(min-width: 750px)').matches;
          const canScroll = isDesktop && track.scrollWidth > track.clientWidth + 2;

          controls.hidden = !canScroll;
          previousButton.disabled = !canScroll || track.scrollLeft <= 2;
          nextButton.disabled = !canScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };

        const scrollByOneCard = (direction) => {
          const firstCard = track.querySelector('.mangmi-feature-grid__item');
          if (!firstCard) return;

          const styles = window.getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = firstCard.getBoundingClientRect().width + gap;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          track.scrollBy({
            left: direction * distance,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        };

        previousButton.addEventListener('click', () => scrollByOneCard(-1));
        nextButton.addEventListener('click', () => scrollByOneCard(1));
        track.addEventListener('scroll', updateControls, { passive: true });

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(updateControls);
          resizeObserver.observe(track);
        } else {
          window.addEventListener('resize', updateControls);
        }

        window.requestAnimationFrame(updateControls);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeMangmiFeatureGrids());
    } else {
      initializeMangmiFeatureGrids();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeMangmiFeatureGrids(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
